module.exports = "<div class=\"checkbox\">\n  <input id=\"{{this.for}}\" type=\"radio\" [class.selected]=\"this.model[this.for]\" name=\"{{this.for}}\" (click)=\"modelFlip()\" >\n  <label style=\"font-size: 18px !important;\" for=\"{{this.for}}\" >{{text}}</label>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// C:/git/SynergiPartners 7-Eleven Screening/src/app/utility-components/check-box/check-box.component.html
// module id = ../../../../../src/app/utility-components/check-box/check-box.component.html
// module chunks = main